import { WebLayout } from 'components/Layout';
import React, { useEffect } from 'react';
import { Motion, spring } from 'react-motion';
import { ArrowRight } from 'lucide-react';
import RegisterImg from 'assets/register.svg';
import OurPartners from '../components/OurPartners';

export const Company = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <WebLayout>
      {/* Header Section with Fade & Slide In */}
      <Motion
        defaultStyle={{ opacity: 0, translateY: 20 }}
        style={{
          opacity: spring(1, { stiffness: 60, damping: 15 }),
          translateY: spring(0, { stiffness: 60, damping: 15 }),
        }}
      >
        {(style) => (
          <div
            className="bg-[#26C4FF] p-6 md:p-12 mt-8 mb-8 md:px-40 text-white text-center"
            style={{ opacity: style.opacity, transform: `translateY(${style.translateY}px)` }}
          >
            <h1 className="text-4xl md:text-7xl font-black mb-4">Wire24</h1>
            <p className="text-lg md:text-xl font-light">
              Empowering secure and seamless money transfers globally.
            </p>
          </div>
        )}
      </Motion>

      {/* About Section */}
      <section className="py-10">
        <div className="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
          <div className="flex flex-col lg:flex-row items-center gap-8 xl:gap-14">
            {/* Image with Slide In from Left */}
            <Motion
              defaultStyle={{ opacity: 0, translateX: -50 }}
              style={{
                opacity: spring(1, { stiffness: 80, damping: 20 }),
                translateX: spring(0, { stiffness: 80, damping: 20 }),
              }}
            >
              {(style) => (
                <div
                  className="lg:max-w-[570px] w-full"
                  style={{ opacity: style.opacity, transform: `translateX(${style.translateX}px)` }}
                >
                  <img
                    src={RegisterImg}
                    alt="About Wire24"
                    className="mx-auto md:mx-0 w-[60vw] md:w-full md:-mt-48 md:-ml-24"
                  />
                </div>
              )}
            </Motion>

            {/* Text Content with Slide In from Right */}
            <Motion
              defaultStyle={{ opacity: 0, translateX: 50 }}
              style={{
                opacity: spring(1, { stiffness: 80, damping: 20 }),
                translateX: spring(0, { stiffness: 80, damping: 20 }),
              }}
            >
              {(style) => (
                <div
                  className="lg:max-w-[490px] w-full"
                  style={{ opacity: style.opacity, transform: `translateX(${style.translateX}px)` }}
                >
                  <span className="inline-flex text-primary font-semibold text-4xl mb-2.5">
                    Who we are
                  </span>
                  <h1 className="font-bold text-2xl sm:text-3xl lg:text-4xl text-dark mb-5">
                    Revolutionizing Digital Remittance
                  </h1>
                  <p>
                    Wire24 is a cutting-edge digital remittance platform dedicated to making money
                    transfers secure, fast, and cost-effective. With a focus on financial inclusion,
                    we help individuals and businesses move money across borders seamlessly.
                  </p>
                  <p className="mt-4">
                    Our technology-driven solutions ensure competitive exchange rates, minimal
                    transaction fees, and top-tier security. Whether you’re sending money to family
                    or supporting global business operations, Wire24 is your trusted partner in
                    digital finance.
                  </p>
                  {/* <div className="mt-6">
                    <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded inline-flex items-center transition-colors duration-300">
                      Learn More
                      <ArrowRight className="ml-2 w-5 h-5" />
                    </button>
                  </div> */}
                </div>
              )}
            </Motion>
          </div>
        </div>
      </section>

      {/* <OurPartners /> */}
    </WebLayout>
  );
};
